@let template = template$ | async;
@if (template) {
  <div [ngClass]="{ 'is-edit': template.is_edit }" class="template-selector-grid-container">
    @if (template.is_edit) {
      <app-floating-input
        data-cy="template-name-input"
        #inputElement
        [name]="'template_name' + template.id"
        class="template-name-input text-size_xl"
        [ngModel]="template.name"
        (ngModelChange)="onInputChange($event)"
        (inputBlurred)="setEditMode(false)"
        (iconClick)="setEditMode(false)"
        (enterPressed)="setEditMode(false)"
        iconClass="icon-input-box-checked"
      />
      <!--      font-size: 22px;-->
      <!--      top: 17px;-->
      <!--      right: 6px;-->
      <!--      line-height: 1;-->
    } @else {
      <span>{{ template.name }}</span>
    }

    @if (template.has_error && !template.is_edit) {
      <span
        appTooltip="An error occurred during saving this template. Please review it."
        tooltipPosition="top"
        class="icon-warning text-red-500 text-[22px]"
      ></span>
    } @else if (template.is_pending && !template.is_edit) {
      <span
        appTooltip="This template is not saved yet. Some fields may be missing, please review it."
        tooltipPosition="top"
        class="icon-warning text-yellow-400 text-[22px]"
      ></span>
    }

    @if (!template.is_edit && template.has_permissions) {
      <app-styled-options-list
        class="col-start-3"
        [listItems]="template.permissions | optionPermissions"
        (selectedOption)="registerOption($event)"
        [stopClickPropagation]="true"
      >
        <span class="icon-options-inverted text-[22px] cursor-pointer text-blue-700 flex items-center"></span>
      </app-styled-options-list>
    }

    @if (!template.is_edit && !template.has_permissions && 'team' in template && template.team) {
      <span
        [appTooltip]="templateTeamTooltip"
        tooltipPosition="bottom"
        class="col-start-3 icon-info-filled text-[22px] text-navy-700"
      ></span>

      <ng-template #templateTeamTooltip>
        <div class="flex flex-col items-center gap-2">
          <div class="text-size_m">Template Is Owned By</div>
          <div class="text-size_l font-semibold">
            {{ template.team.title }}
          </div>
        </div>
      </ng-template>
    }
  </div>
}
